import "./base";
import React from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App";
import { unregister } from "./registerServiceWorker";
import store from "./store.js";
import { Provider } from "react-redux";
import ReactGA from "react-ga";
import IntAnalytics from "./IntAnalytics";
import * as d3 from "d3";
import actions from "./store/actions";
import Services from "./Services";
import { getLogoWidth } from "./components/Header/Header";


const logo = (a, b) => {
  let doc = document.getElementById("favicon");
  doc.setAttribute(a, b);
};

if (document.location.href.indexOf("localhost") != -1) {
  logo("href", "/devIcon.svg");
} else {
  if (document.location.href.indexOf("staging") != -1) {
    logo("href", "/stagingIcon.svg");
  } else if (document.location.href.indexOf("dev") != -1) {
    logo("href", "/devIcon.svg");
  } else if (document.location.href.indexOf("bilitielectric") != -1) {
    logo("href", "/biliti_icon.svg");
  } else if (document.location.href.indexOf("etomotors") != -1) {
    logo("href", "/keto_logo.png");
  } else if (document.location.href.indexOf("mondays") != -1) {
    logo("href", "/monday.svg");
  } else if (document.location.href.indexOf("gofuel") != -1) {
    logo("href", "/gozap.svg");
  } else if (document.location.href.indexOf("libtracx") != -1) {
    logo("href", "/cruzex.png");
  } else if (document.location.href.indexOf("easyv") != -1) {
    logo("href", "/easyv_fav.png");
  }  else {
    logo("href", "/prodIcon.svg");
  }
}

window.d3 = d3;
ReactGA.initialize("UA-130895276-2");
ReactGA.pageview("/");

// mixpanel.init("b252d85eb9a02bea2baee2479d1a00d6");
// mixpanel.disable();

IntAnalytics.initialize("track");
IntAnalytics.pageView({ page_id: "loading" });

window.logout = () => {
  store.dispatch({ type: actions.AUTH_FAILURE });
};

window.dispatchStoreEvent = (e) => store.dispatch(e);

// Create root
const container = document.getElementById("root");
const root = createRoot(container);

// Render app
root.render(
  <Provider store={store}>
    <App store={store} />
  </Provider>
);

var qwe123 = "qwe1234";
unregister();
